package com.schoolconnect.app.runtime

import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.SharedFlow
import kotlinx.coroutines.flow.asSharedFlow

object AuthSessionCenter {
    private val _sessionExpiredEvents = MutableSharedFlow<Unit>(
        extraBufferCapacity = 8
    )

    val sessionExpiredEvents: SharedFlow<Unit> = _sessionExpiredEvents.asSharedFlow()

    fun emitSessionExpired() {
        _sessionExpiredEvents.tryEmit(Unit)
    }
}
